<template>
  <!-- All Employees Content From Employee List Component -->
  <div>
    <div
      class="page-header-search text-auto row no-gutters align-items-center justify-content-between"
    >
      <div class="col">
        <div class="row no-gutters align-items-end pull-right">
          <div class="pr-4">
            <div class="d-flex align-items-center">
              <span
                class="page-info px-2 fw-600"
                style="color: #4e5764;font-size: 14px;"
              >{{ getSkipCount }} - {{ total > skip + limit ? skip + limit : total }} of {{ total }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!ajaxCallinprogress && !employeeData.length && !searchKey.length">

      <div
        class="col-lg-12 text-center py-3 px-3 mt-10"
        v-if="!ajaxCallinprogress && !employeeData.length && searchKey.length"
        style="justify-content: center;"
      >
        <div class="">
          <img
            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/search.svg"
            alt="Search Image"
            class="img-fluid"
            style="width: 120px;"
          />
          <h5 class="pt-3 fs-14" style="color: #00448b;">
            Sorry We Couldn’t Find Any Matches for
            <span class="text-danger">"{{ this.searchKey }}"</span>
          </h5>
        </div>
      </div>
      <div class="col-lg-12 py-5 px-3 mt-10" v-if="ajaxCallinprogress">
        <div class="flex-container">
          <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
        </div>
      </div>
      <div class="col-lg-12 text-center py-3 px-3 mt-10">
        <img
          src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/no_employees_blue.svg"
          alt="No Employees"
          class="img-fluid"
          style="width: 150px;"
        />
        <h5 class="pt-3" style="color: #00448b;">No Employees</h5>
      </div>
    </div>
    <div v-else>
      <div  v-if="ajaxCallinprogress && !employeeData.length" class="d-flex justify-content-center w-100">
          <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
      </div>
      <div v-if="show == 'grid'" class="employee-section">
        <div class="card-box employee-box" v-for="(employee, index) in employeeData" :key="index">
          <div class="md-card employee-card md-card-hover">
            <div class="md-card-head md-employee-card-head" style="overflow: hidden;">
              <div class="text-center">
                <div class="profile-img-div border-white1" @click="goToEmployee(employee._id)">
                  <img
                    class="md-card-head-avatar"
                    :src="employee.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'"
                    :alt="employee.first_name"
                  />
                </div>
              </div>

              <div
                class="md-card-head-menu"
                v-if="employee._id != loggedInUser._id && (admin || superAdmin)"
              >
                <div class="dropdown dropleft dropconnection">
                  <div
                    class="dropdown-toggle dropdown-dept row align-items-center justify-content-center no-gutters px-0"
                    role="button"
                    id="dropdownLanguageMenu"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="icon icon-dots-vertical" style="color:#fff"></i>
                  </div>
                  <div
                    class="dropdown-menu dropdown-dept-menu"
                    aria-labelledby="dropdownLanguageMenu"
                  >
                    <a
                      class="dropdown-item"
                      href="javascript:;"
                      @click="terminateEmployeeSelected(employee)"
                    >
                      <div class="row no-gutters align-items-center flex-nowrap">
                        <i class="icon icon-pencil" style="font-size: 14px;width: 24px;height: 24px;line-height: 24px;"></i>
                        <span class="pl-0 pr-3">Terminate</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <h3 class="md-card-head-text text-center" @click="goToEmployee(employee._id)" style="height: 28px; overflow: hidden; text-overflow: ellipsis;">
                {{ employee.full_name || '-'}}
              </h3>
            </div>
            <div class="md-card-content text-center md-employee-card-footer">
              <span class="content">
                <span class="head" style="width: 4em; margin-right: 10px;">Email</span>
                  <el-tooltip class="item" effect="dark" :content="employee.email_id" placement="bottom">
                    <span v-if="'email_id' in  employee && employee.email_id">{{ employee.email_id }}</span>
                    <span v-else>-</span>
                  </el-tooltip>
              </span>
              <span class="content" style="border-bottom: 0 !important;">
                <span class="head">Tel</span>
                <span
                  v-if="'phone_number' in  employee && employee.phone_number.value.phone_number"
                >{{ employee.phone_number ? employee.phone_number.value.phone_number : "-" }}</span>
                <span v-else>-</span>
              </span>
              <a v-if="employee._id != loggedInUser._id && (admin || superAdmin)" href="javascript:;" class="btn btn-new-danger btn-wide mt-4 mx-10" @click="terminateEmployeeSelected(employee)">TERMINATE</a>
              <a v-else href="javascript:;" class="btn btn-new-danger btn-wide mt-4 mx-10 disabled"></a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="show == 'list'" style="overflow: auto; max-height: 69em;">
        <table class="table table-white-nostripe">
          <thead>
            <tr>
              <th>Name & Employee ID</th>
              <th>Joined On</th>
              <th>Reporting Manager</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Business Unit</th>
              <th>Department</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="ajaxCallinprogress && !employeeData.length && searchKey.length">
              <td colspan="7" class="text-center">
                  <div class="d-flex justify-content-center">
                      <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" />
                  </div>
              </td>
            </tr>
            <tr v-if="!ajaxCallinprogress && !employeeData.length && searchKey.length">
              <td colspan="7" class="text-center">
                  <div class="">
                    <img
                      src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/search.svg"
                      alt="Search Image"
                      class="img-fluid"
                      style="width: 120px;"
                    />
                    <h5 class="pt-3 fs-14" style="color: #00448b;">
                      Sorry We Couldn’t Find Any Matches for
                      <span class="text-danger">"{{ this.searchKey }}"</span>
                    </h5>
                  </div>
              </td>
            </tr>
            <tr v-for="(employee, index) in employeeData" :key="index">
              <td class="d-flex">
                <img :src="employee.profile_pic" style="width: 40px; height: 40px;" />
                <span class="d-flex flex-column ml-2">
                  <span
                    style="color: #00448b; cursor: pointer"
                    @click="goToEmployee(employee._id)"
                  >{{ employee.full_name || '-' }}</span>
                  {{ employee.employee_id || '-' }}
                </span>
              </td>
              <td>-</td>
              <td>{{ employee.hasOwnProperty("reporting_manager") ? employee.reporting_manager.full_name || "-" : "-" }}</td>
              <td>{{ employee.email_id }}</td>
              <td>{{ employee.phone_number ? employee.phone_number.value.phone_number : '-' }}</td>
              <td>-</td>
              <td>{{ employee.department || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <terminate-employee modal_name="terminateEmployee" @terminateEmployee="terminateEmployee" :employee_name="selectedEmployee.full_name"></terminate-employee>
  </div>
</template>
<style>
.btn.btndisabled:disabled {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: rgba(0, 0, 0, 0.26) !important;
  background: transparent !important;
  cursor: not-allowed;
  pointer-events: all;
  opacity: 1;
}
#searchdigi #newsearch input[type="text"] {
  background: url(https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/search-dark.png)
    no-repeat 10px 7px #d6e2ef;
  border: 1px solid #a2aaa9;
  font-size: 13px;
  font-weight: 600;
  color: #303031;
  width: 230px;
  padding: 6px 15px 6px 35px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  -webkit-transition: all 0.7s ease 0s;
  -moz-transition: all 0.7s ease 0s;
  -o-transition: all 0.7s ease 0s;
  transition: all 0.7s ease 0s;
}

#searchdigi #newsearch input[type="text"]:focus {
  background: url(https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/search-white.png)
    no-repeat 10px 7px rgb(13, 132, 242);
  width: 280px;
  border: 1px solid #00448b;
  color: #fff;
}
#searchdigi #newsearch input[type="text"]:focus::-webkit-input-placeholder {
  color: #fff !important;
}

.dropdown-toggle.dropdown-dept::after {
  content: none !important;
}

.dropdown-menu.dropdown-dept-menu {
  min-width: 10rem !important;
  background-color: #fff !important;
  font-size: 14px !important;
  border-radius: 0px !important;
  border: none !important;
  box-shadow: none !important;
  top: 26px !important;
  left: 16px !important;
  margin: 0.25rem 0rem 0 !important;
  border-radius: 6px !important;
  padding: 0rem 0rem !important;
}

.dropdown-menu.dropdown-dept-menu .dropdown-item {
  line-height: 3.2rem !important;
  height: 3.2rem !important;
  text-decoration: none;
  color: #303031;
}
.dropdown-menu.dropdown-dept-menu .dropdown-item:hover {
  color: #00448b;
  background-color: transparent !important;
  border-radius: 6px !important;
}
.employee-section {
  font-weight: bold;
  line-height: 1.22;
  color: #303031;
  margin-top: 0px;
  margin-bottom: 30px;
  text-align: left;
  padding-top: 0px;
  padding-bottom: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 230px));
  gap: 1rem;
  max-height: 63em;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-flow: row !important;
  flex-wrap: wrap !important;
}
.card-box.employee-box {
  box-sizing: border-box;
  padding-left: 15px;
  padding-bottom: 20px;
  display: inline-block;
  width: 260px;
}
</style>
<script>
import { User } from "./mixins/user";
import { EmployeeManage } from "./mixins/employees";
import Connection from "./mixins/connection";
import { EventBus } from "./eventBus/nav-bar-event.js";
import { HalfCircleSpinner } from "epic-spinners";
import TerminateEmployee from "./alertModals/TerminateEmployee";
export default {
  data() {
    return {
      userSearchKey: "",
      employeeData: [],
      searchKey: "",
      userSearchData: {},
      statusKey: "",
      total: 0,
      ajaxCallinprogress: false,
      skip: 0,
      limit: 10,
      requestResponse: false,
      show: localStorage.getItem("show") ? localStorage.getItem("show") : "grid",
      selectedEmployee: "",
    };
  },
  components: {
    HalfCircleSpinner,
    TerminateEmployee,
  },
  mixins: [User, EmployeeManage, Connection],
  methods: {
    // Employees Business Profile REdirection
    goToEmployee(emp_id) {
      this.$router.push({ name: "BusinessProfile", params: { id: emp_id, company_id: this.$route.params.id } });
    },
    addEmployee() {
      //this.$modal.show("add-employee-modal")
      this.$router.push("/addemployee");
    },
    terminateEmployeeSelected(employee) {
      this.selectedEmployee = employee;
      this.$modal.show("terminateEmployee");
    },
    terminateEmployee() {
      this.changeEmployeeStatus('terminated', this.selectedEmployee._id);
      this.$modal.hide("terminateEmployee");
    },
    // Sending Connection Invite to Employee
    async addConnectionUser(company_id = null, user_id) {
      this.requestResponse = true;
      var request_type = "business";
      if (this.account) {
        request_type = "employee";
      }
      let response = await this.sendBusinessRequestAPI({
        sent_to: user_id,
        isCompany: true,
        request_type: request_type,
        receiver_company: company_id,
      });
      if (response) {
        this.requestResponse = false;
        this.getEmployees("active");
        this.$awn.success("Request Sent Successfully");
      }
    },
    clearSearchKey() {
      EventBus.$on("clearKey", () => {
        this.searchKey = "";
        this.getEmployees("active");
      });
    },
    nextPage() {
      let skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
      if (skip_temp >= this.total) {
        return;
      }
      this.skip = skip_temp;
      this.getEmployees("active");
    },
    previousPage() {
      if (this.skip == 0) {
        return;
      }
      this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
      this.getEmployees("active");
    },

    // Connect, Disconnect and Delete Status for Request Sent
    changeConnectionStatusUser(status, id) {
      this.requestResponse = true;
      this.$http
        .post("/connections/change_connection_status", {
          connection_status: status,
          _id: id,
        })
        .then(res => {
          if (res.data.status_id == 1) {
            this.requestResponse = false;
            if (status == "disconnected") {
              this.$awn.success("Request Disconnected Successfully");
            }
            if (status == "delete") {
              this.$awn.success("Request Deleted Successfully");
            }
            if (status == "connected") {
              this.$awn.success("Request Accepted Successfully");
            }
            this.getEmployees("active");
          }
        });
    },

    // Terminating Employee From Company
    changeEmployeeStatus(status, id) {
      this.ajaxCallinprogress = true;
      this.$http
        .post("/employees/change_employee_status", {
          status: status,
          employee_id: id,
        })
        .then(res => {
          if (res.data.status_id == 1) {
            if (status == "terminated") {
              this.$awn.success("Employee Terminated Successfully");
            }
            this.getEmployees("active");
            this.ajaxCallinprogress = false;
            //this.getUserEmployeeRequest();
          } else {
            this.$swal({
              title: "Error",
              text: "Please try again",
              type: "error",
              confirmButtonText: "OK",
              confirmButtonColor: "#005dae",
            });
          }
        });
    },
  },
  created() {
    this.getEmployees("active");
    this.clearSearchKey();
    EventBus.$on("toggleview", option => {
      this.show = option;
    });
    EventBus.$on("previouspage", () => {
      if (this.getSkipCount > 1) {
        this.previousPage();
      };
    });
    EventBus.$on("nextpage", () => {
      this.nextPage();
    });
    EventBus.$on("searchemployees", searchkey => {
      this.searchKey = searchkey;
      this.getEmployees('active');
    });
  },
  computed: {
    getSkipCount() {
      if (this.total == 0) {
        return 0;
      } else {
        let skip_count = this.skip > this.total ? this.total : this.skip + 1;
        return skip_count;
      }
    },
    account() {
      return this.$store.getters.account;
    },
    admin() {
      return this.$store.getters.isAdmin;
    },
    superAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    loggedInUser() {
      return this.$store.state.loggedInUser;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AllEmployees.vue